import {
  Stack,
  useMantineTheme,
  Text,
  Tooltip,
  Paper,
  TooltipProps,
} from '@mantine/core';
import dayjs from 'dayjs';
import React from 'react';

import { DeviceStatusType } from '@portals/types';

import { DeviceStatusBadge } from './DeviceStatusBadge';
import { DeviceStatusTimelineType } from '../types/device-status-incident-timeline-widget.types';
import { getDeviceStatusColor } from '../utils/utils';

interface DeviceStatusBarProps {
  height: number;
  x: number;
  y: number;
  status: DeviceStatusType;
  width: number;
  start: DeviceStatusTimelineType['start'];
  end: DeviceStatusTimelineType['end'];
  meta: DeviceStatusTimelineType['meta'];
}

export function DeviceStatusBar({
  status,
  y,
  x,
  height,
  width,
  meta,
}: DeviceStatusBarProps) {
  const theme = useMantineTheme();
  const statusColor = getDeviceStatusColor(status);
  let fill;

  if (!status) {
    fill = theme.white;
  } else {
    fill = theme.fn.themeColor(statusColor.indicator);
  }

  const startTimestamp = dayjs(meta.actualStart)
    .tz('UTC')
    .format('MMM DD, YYYY hh:mm A');
  const endTimestamp = dayjs(meta.actualEnd)
    .tz('UTC')
    .format('MMM DD, YYYY hh:mm A');

  return (
    <Tooltip.Floating
      label={
        <Paper p="xl" radius="lg">
          <Stack spacing="sm" align="flex-start">
            <DeviceStatusBadge status={status} />

            <Stack spacing={4}>
              <Text>From: {startTimestamp}</Text>

              <Text>To: {endTimestamp}</Text>
            </Stack>
          </Stack>
        </Paper>
      }
      styles={tooltipStyles}
      position="top"
    >
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill={fill}
          stroke={theme.fn.themeColor(statusColor.borderColor)}
          strokeWidth={1}
        />
      </g>
    </Tooltip.Floating>
  );
}

const tooltipStyles: TooltipProps['styles'] = (theme) => ({
  tooltip: {
    backgroundColor: theme.white,
    borderRadius: theme.radius.lg,
    boxShadow: '0px 11px 23.9px 0px rgba(0, 0, 0, 0.19)',
  },
});
